<button
  class="timeline-layer-add hide-on-recording hide-on-playback"
  (click)="onButtonClick()"
  title="Add a new layer"
  i18n-title
>
  <span class="timeline-layer-add__icon icon-add-box"></span>
  <span i18n>Add a new layer</span>
</button>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer-add/timeline-layer-add.component.html